import { Injectable, inject } from '@angular/core';
import { GoogleSheetSyncFacade } from '@mode/dataset/google/contract';
import { select, Store } from '@ngrx/store';

import * as GoogleSheetSyncActions from './google-sheet-sync.actions';
import * as GoogleSheetSyncSelectors from './google-sheet-sync.selectors';

@Injectable()
export class GoogleSheetSyncFacadeService implements GoogleSheetSyncFacade {
  constructor(private store: Store) {}

  isSyncing$ = this.store.pipe(select(GoogleSheetSyncSelectors.selectIsSyncing));

  googleSheetSyncError$ = this.store.pipe(select(GoogleSheetSyncSelectors.selectGoogleSheetSyncError));

  datasetEditorSyncGoogleSheet(accountId: string, datasetId: string) {
    this.store.dispatch(GoogleSheetSyncActions.datasetEditorSyncGoogleSheet({ accountId, datasetId }));
  }
}
